import { faUpload } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '../../common';

type UploadFilePropsType = {
  onClick: () => void;
  disabled?: boolean;
};

export const UploadFile: React.FC<UploadFilePropsType> = ({
  onClick,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <MenuItem
      leftSection={<FontAwesomeIcon icon={faUpload} />}
      onClick={onClick}
      disabled={disabled}
    >
      {t('FILE_TREE_CONTEXT_MENU.UPLOAD_FILE')}
    </MenuItem>
  );
};
